/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LandlordSlaContractDto } from './LandlordSlaContractDto';
import {
    LandlordSlaContractDtoFromJSON,
    LandlordSlaContractDtoFromJSONTyped,
    LandlordSlaContractDtoToJSON,
    LandlordSlaContractDtoToJSONTyped,
} from './LandlordSlaContractDto';

/**
 * 
 * @export
 * @interface LandlordPartnerRowDto
 */
export interface LandlordPartnerRowDto {
    /**
     * 
     * @type {string}
     * @memberof LandlordPartnerRowDto
     */
    relationshipId: string;
    /**
     * 
     * @type {string}
     * @memberof LandlordPartnerRowDto
     */
    partnerOrgId: string;
    /**
     * 
     * @type {string}
     * @memberof LandlordPartnerRowDto
     */
    partnerName: string;
    /**
     * 
     * @type {boolean}
     * @memberof LandlordPartnerRowDto
     */
    isSameCompanyAsOperator: boolean;
    /**
     * 
     * @type {LandlordSlaContractDto}
     * @memberof LandlordPartnerRowDto
     */
    slaContract?: LandlordSlaContractDto | null;
}

/**
 * Check if a given object implements the LandlordPartnerRowDto interface.
 */
export function instanceOfLandlordPartnerRowDto(value: object): value is LandlordPartnerRowDto {
    if (!('relationshipId' in value) || value['relationshipId'] === undefined) return false;
    if (!('partnerOrgId' in value) || value['partnerOrgId'] === undefined) return false;
    if (!('partnerName' in value) || value['partnerName'] === undefined) return false;
    if (!('isSameCompanyAsOperator' in value) || value['isSameCompanyAsOperator'] === undefined) return false;
    return true;
}

export function LandlordPartnerRowDtoFromJSON(json: any): LandlordPartnerRowDto {
    return LandlordPartnerRowDtoFromJSONTyped(json, false);
}

export function LandlordPartnerRowDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LandlordPartnerRowDto {
    if (json == null) {
        return json;
    }
    return {
        
        'relationshipId': json['relationshipId'],
        'partnerOrgId': json['partnerOrgId'],
        'partnerName': json['partnerName'],
        'isSameCompanyAsOperator': json['isSameCompanyAsOperator'],
        'slaContract': json['slaContract'] == null ? undefined : LandlordSlaContractDtoFromJSON(json['slaContract']),
    };
}

export function LandlordPartnerRowDtoToJSON(json: any): LandlordPartnerRowDto {
    return LandlordPartnerRowDtoToJSONTyped(json, false);
}

export function LandlordPartnerRowDtoToJSONTyped(value?: LandlordPartnerRowDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationshipId': value['relationshipId'],
        'partnerOrgId': value['partnerOrgId'],
        'partnerName': value['partnerName'],
        'isSameCompanyAsOperator': value['isSameCompanyAsOperator'],
        'slaContract': LandlordSlaContractDtoToJSON(value['slaContract']),
    };
}

